<template>
    <div class="col-xs-12" v-if="parseInt(errors.items.length)">
        <div class="alert alert-danger">
            <ul>
                <li v-for="(error) in errors.items">{{ error.msg }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MostraMensagemValidacao"
    }
</script>